import { html } from "lit";

export const paymentStyles = html`
  <style>
    .zpay-overlay {
      position: fixed;
      inset: 0;
      background: rgba(20, 24, 28, 0.55);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2147483000;
      padding: 1rem;
    }
    .zpay-inline {
      width: 100%;
    }
    .zpay-modal {
      background: #fff;
      color: #1f2a22;
      border-radius: 12px;
      max-width: 420px;
      width: 100%;
      padding: 1.25rem;
      font-family: system-ui, sans-serif;
      box-shadow: 0 20px 60px -20px rgba(0, 0, 0, 0.5);
    }
    .zpay-modal h3 {
      margin: 0 0 0.5rem;
      font-size: 1.1rem;
    }
    .zpay-total {
      display: flex;
      justify-content: space-between;
      font-weight: 700;
      margin: 0.5rem 0 0.85rem;
    }
    /* Sits directly under an un-quoted total, so it reads as a qualifier on
       the number above it rather than a separate row. */
    .zpay-total-note {
      margin: -0.6rem 0 0.85rem;
      font-size: 0.78rem;
      color: #6b7a70;
    }
    #zpay-prbutton {
      /* B2: reserves the exact box the (possibly slot-projected) Stripe wallet
             button will occupy — matches PR_BUTTON_HEIGHT (mountWalletButton).
             Kept as a literal: lit-html bindings inside a static <style>
             block aren't reliable across engines, so this constant is only
             interpolated into the Stripe JS 'style' option, not here. */
      min-height: 44px;
      margin-bottom: 0.75rem;
    }
    .zpay-methods {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      margin-bottom: 0.85rem;
    }
    .zpay-method {
      display: flex;
      align-items: center;
      gap: 0.65rem;
      width: 100%;
      text-align: left;
      appearance: none;
      background: #fff;
      border: 1.5px solid #e2e2e2;
      border-radius: 8px;
      padding: 0.5rem 0.75rem;
      font: inherit;
      color: #1f2a22;
      cursor: pointer;
    }
    .zpay-method.sel {
      border-color: #1f2a22;
      background: #f6f8f7;
    }
    .zpay-method .ico {
      width: 22px;
      height: 22px;
      flex: 0 0 auto;
    }
    .zpay-method .lbl {
      display: flex;
      flex-direction: column;
      gap: 0;
      min-width: 0;
    }
    .zpay-method .lbl strong {
      font-size: 0.9rem;
      font-weight: 600;
      line-height: 1.2;
    }
    .zpay-method .lbl span {
      font-size: 0.75rem;
      line-height: 1.2;
      color: #6b6b6b;
    }
    .zpay-wallet-hint {
      font-size: 0.85rem;
      color: #516056;
      margin: 0 0 0.55rem;
    }
    .zpay-or {
      display: flex;
      align-items: center;
      text-align: center;
      color: #8a8a8a;
      font-size: 0.8rem;
      margin: 0 0 0.75rem;
    }
    .zpay-or::before,
    .zpay-or::after {
      content: "";
      flex: 1;
      height: 1px;
      background: #e2e2e2;
    }
    .zpay-or span {
      padding: 0 0.6rem;
    }
    .zpay-card-fields {
      display: grid;
      gap: 0.75rem;
      margin-bottom: 0.75rem;
    }
    .zpay-card-details {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.75rem;
    }
    .zpay-card-input {
      position: relative;
      border: 1px solid #e2e2e2;
      border-radius: 8px;
      padding: 0.7rem;
      min-width: 0;
      background: #fff;
    }
    .zpay-card-fields[data-loading] .zpay-card-input {
      background: #f6f8f7;
    }
    .zpay-card-loading {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      padding: 0 0.7rem;
      color: #516056;
      font-size: 0.8rem;
      pointer-events: none;
    }
    .zpay-card-input.focused,
    .zpay-card-input:focus-within {
      border-color: var(--zui-accent, #4f9db5);
      box-shadow: 0 0 0 1px var(--zui-accent, #4f9db5);
    }
    #zpay-card,
    #zpay-card-expiry,
    #zpay-card-cvc {
      /* Stripe projects into this inner box; padding stays on its wrapper. */
      min-height: 20px;
    }
    .zpay-row {
      display: flex;
      gap: 0.5rem;
    }
    /* Date inputs have no usable placeholder, so the org-required date of
       birth needs a visible label where the other fields carry their own. */
    .zpay-field-label {
      display: block;
      font-size: 0.8rem;
      color: #516056;
      margin-bottom: 0.25rem;
    }
    @media (max-width: 540px) {
      .zpay-row {
        flex-direction: column;
      }
    }
    .zpay-input {
      width: 100%;
      min-width: 0;
      max-width: 100%;
      box-sizing: border-box;
      border: 1px solid #e2e2e2;
      border-radius: 8px;
      padding: 0.55rem 0.6rem;
      margin-bottom: 0.5rem;
      font: inherit;
      font-size: 16px;
    }
    .zpay-input[type="date"] {
      appearance: none;
      -webkit-appearance: none;
      display: block;
      min-height: 44px;
    }
    .zpay-status {
      margin: 0 0 0.6rem;
      font-size: 0.85rem;
      font-weight: 600;
      color: #516056;
      text-align: center;
    }
    /* PLAT-5624: primary submit for the STANDALONE overlay presentation
           only (see renderOverlaySubmit) — the inline hosts render their own
           CTA and never show this. Uses the caller-supplied accent so the
           overlay matches the embed's theme. */
    .zpay-btn {
      display: block;
      width: 100%;
      appearance: none;
      border: 0;
      border-radius: var(--zui-btn-radius, 10px);
      background: var(--zui-accent, #4f9db5);
      color: var(--zui-btn-text, #fff);
      font: inherit;
      font-weight: 700;
      padding: 0.75rem 1rem;
      cursor: pointer;
    }
    .zpay-btn:disabled {
      background: #d8d6cf;
      color: #6b6b6b;
      cursor: default;
    }
    .zpay-link {
      display: block;
      width: 100%;
      background: none;
      border: 0;
      color: #6b6b6b;
      margin-top: 0.6rem;
      cursor: pointer;
      font: inherit;
    }
    .zpay-err {
      color: #b4541f;
      font-size: 0.85rem;
      margin-bottom: 0.6rem;
    }
    .zpay-note {
      font-size: 0.9rem;
      color: #516056;
      line-height: 1.5;
    }
    .zpay-cards {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      margin-bottom: 0.75rem;
    }
    .zpay-card-opt {
      display: flex;
      align-items: center;
      gap: 0.55rem;
      width: 100%;
      text-align: left;
      appearance: none;
      background: #fff;
      border: 1.5px solid #e2e2e2;
      border-radius: 8px;
      padding: 0.6rem 0.7rem;
      font: inherit;
      font-size: 0.9rem;
      color: #1f2a22;
      cursor: pointer;
    }
    .zpay-card-opt.sel {
      border-color: #1f2a22;
      background: #f6f8f7;
    }
    .zpay-radio {
      width: 16px;
      height: 16px;
      border-radius: 999px;
      border: 1.5px solid #c4c4c4;
      flex: 0 0 auto;
      position: relative;
    }
    .zpay-card-opt.sel .zpay-radio {
      border-color: #1f2a22;
    }
    .zpay-card-opt.sel .zpay-radio::after {
      content: "";
      position: absolute;
      inset: 3px;
      border-radius: 999px;
      background: #1f2a22;
    }
  </style>
`;
